import styled from 'styled-components';

export const Portfolio = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const PortfolioItem = styled.div`
  width: 24%;
  margin-bottom: 20px;
  line-height: 0%;

  img {
    width: 100%;
  }

  figure {
    border:2px solid #333;
    margin: 0;
    padding: 0;
    overflow: hidden;
    position: relative;
  }

  figcaption {
    background: #fff;
    color: #333;
    font-size: 0.85em;
    padding: 10px 2% 15px 2%;
    line-height: 140%;
    position: absolute;
    left: 0;
    bottom: -5px;
    width: 96%;
    opacity: 1.0;
    transform: translateY(100%);
    transition: transform 0.4s, opacity 0.1s 0.3s;
  }

  :hover figcaption {
    opacity: 1;
    transform: translateY(1%);
    transition: transform 0.4s, opacity 0.1s;
  }

  figcaption h3 {
    font-size: 1.2em;
    margin-bottom: 5px;
  }

  @media (max-width: 992px) {

    margin-bottom: 5px;

  }

  @media (max-width: 767px) {

    width:48%;

  }

`;



// WEBPACK FOOTER //
// ./src/components/digitalNomad/LatestWork.style.js